
import BusinessApi from './src/BusinessApi'
import BusinessTypeApi from './src/BusinessTypeApi'
import ScenicApi from './src/ScenicApi'
import BusinessQueryOrderApi from './src/BusinessQueryOrderApi'
import BusinessBalanceApi from './src/BusinessBalanceApi'
import OrgApi from './src/OrgApi'
import ChildBusinessApi from './src/ChildBusinessApi'
import BankApi from './src/BankApi'
import BusinessOutPaymentApi from './src/BusinessOutPaymentApi'
import UserApi from './src/UserApi'
import UserRoleApi from './src/UserRoleApi'
import OrgUserApi from './src/OrgUserApi'
import BusinessPayOrderApi from './src/BusinessPayOrderApi'

let apis = {
    BusinessApi,
    BusinessTypeApi,
    BusinessQueryOrderApi,
    BusinessBalanceApi,
    ScenicApi,
    OrgApi,
    ChildBusinessApi,
    BankApi,
    BusinessOutPaymentApi,
    UserApi,
    UserRoleApi,
    OrgUserApi,
    BusinessPayOrderApi
};

export default apis;
